import { render } from "./MeetingRepositoryTable.vue?vue&type=template&id=127f8be6"
import script from "./MeetingRepositoryTable.vue?vue&type=script&lang=js"
export * from "./MeetingRepositoryTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__